<template>
  <!-- 这个是编辑项目的页面 -->
  <div class="contain">
    <!-- 这里边是标题和返回 -->
    <div class="title_box">
      <h4>{{ navigationTitle }}</h4>
      <el-button size="small" type="info" @click="backProject">返回</el-button>
    </div>
    <el-card class="box-card">
      <!-- 这里边是一个表单 -->
      <el-form ref="reference" :model="reference" size="small" label-width="80px" label-position="top" :rules="rules">
        <el-form-item label="名称" prop="name">
          <el-col>
            <el-input type="textarea" v-model="reference.name" placeholder="请输入会议名称"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="会议类别" prop="c_id">
          <el-col :span="6">
            <el-select v-model="reference.c_id" placeholder="请选择">
              <el-option v-for="item in categoryList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="会议时间" prop="start_time">
          <el-col :span="5">
            <el-date-picker v-model="Stage" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期"
              value-format="yyyy-MM-dd" @change="changessss">
            </el-date-picker>
          </el-col>
        </el-form-item>
        <el-form-item label="会议形式" prop="meeting_form">
          <el-col :span="6">
            <el-select v-model="reference.meeting_form" placeholder="请选择" @change="change">
              <el-option v-for="item in meeting_formList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>

        <!-- //e 线下线上 -->
        <el-form-item v-if="meetingIndex == 45" label="会议模式" prop="meeting_mode">
          <el-col :span="6">
            <el-select v-model="reference.meeting_mode" placeholder="请选择">
              <el-option v-for="item in meeting_ModeList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item v-if="meetingIndex == 46" label="请输入线下地址" prop="offline_address">
          <el-col :span="11">
            <el-input v-model="reference.offline_address" placeholder="请输入线下地址"></el-input>
          </el-col>
        </el-form-item>
        <!-- //e 线下线上 -->

        <el-form-item label="PPT准备">
          <el-col :span="6">
            <el-select v-model="reference.ppt" placeholder="请选择是否准备PPT">
              <el-option v-for="item in pptList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="参会专家" prop="expert" required>
          <el-col :span="10">
            <el-select v-model="reference.expert" remote multiple filterable placeholder="参会专家">
              <el-option v-for="item in expertObject" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
              <!-- 这里边再加一个分页 -->
              <!-- <el-pagination
                style="text-align: center;"
                layout="prev, pager, next"
                @current-change="currentchange"
                @prev-click="prevClick"
                @next-click="nextClick"
                :current-page.sync="currentPage"
                hide-on-single-page
                :page-count="expertObject.pages"
              >
              </el-pagination> -->
            </el-select>
          </el-col>
        </el-form-item>
        <!-- 上传logo -->
        <el-form-item label="logo">
          <el-upload name="file" class="avatar-uploader" :action="action" :show-file-list="false"
            :on-success="handleAvatarSuccess" :data="{ file: 'file', model: '' }" ref="imageUrl">
            <img v-if="imageUrl" :src="imageUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <!-- 备注 -->
        <el-form-item label="备注">
          <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="reference.remarks">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" style="background: #484c7f" @click="submitForm('reference')">保存</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>
 
<script>
export default {
  name: 'editorProject',
  data() {
    var validatePass = (rule, value, callback) => {
      if (value.length == 0) {
        callback(new Error('请选择参会专家'));
      } else {
        callback();
      }
    };
    return {
      navigationTitle: '录入会议',
      Stage: [],
      expertObject: [],
      categoryList: [],
      meeting_formList: [],
      meeting_ModeList: [],
      meetingIndex: 0,
      pptList: [
        { name: '有', id: 1 },
        { name: '无', id: 2 },
      ],
      reference: {
        id: '', //点击编辑和修改才会需要
        p_id: '', //项目id  //!项目id需要从另一个页面带过来
        name: '', //会议名称
        c_id: '', //会议分类id
        start_time: '', //开始时间
        end_time: '', //结束时间
        meeting_form: '', //会议形式 
        meeting_mode: '', //会议方式（线上）  
        offline_address: '', //线下地址 
        ppt: '', //1有ppt 2无ppt
        expert: [], //参会专家id，分开    
        logo: '', //头像
        remarks: '', //备注 
      },
      rules: {
        name: [
          { required: true, message: '请输入会议名称', trigger: 'blur' },
        ],
        c_id: [
          { required: true, message: '请选择会议类别', trigger: 'change' }
        ],
        start_time: [
          { required: true, message: '请选择会议时间', trigger: 'change' }
        ],
        meeting_form: [
          { required: true, message: '请选择会议形式', trigger: 'change' }
        ],
        meeting_mode: [
          { required: true, message: '请选择会议模式', trigger: 'change' }
        ],
        offline_address: [
          { required: true, message: '请输入会议地址', trigger: 'blur' }
        ],
        expert: [
          { validator: validatePass, trigger: 'change' }
        ],
      },
      action: `https://laravel.gongshicloud.com/api/index/upload`,
      imageUrl: "",
      value: '',
      // 选择时间
      value1: '',
      // 搜索专家
      loading: false,
      // 参会专家
      value3: ['选项4', '选项3'],
      total: 0,//总条目数
      pagesize: 6,//每页显示条目个数
      currentPage: 1,//当前页数  
    }
  },
  created() {
    if (this.$route.query.id != "") { this.editorConference(this.$route.query.id) } else { this.getProjectList() }
    if (this.$route.query.project_id != '' && this.$route.query.project_id != null && this.$route.query.project_id != undefined) this.reference.p_id = this.$route.query.project_id
    this.getcate()
    this.getForm()
    this.getMode()
    this.getExpertList()
  },
  methods: {
    //编辑进来的
    async editorConference(id) {
      this.navigationTitle = '编辑会议'
      const { data: data } = await this.$http.post('meeting/info', {
        id,
      })
      this.reference = data.data
      this.imageUrl = data.data.logo
      this.meetingIndex = data.data.meeting_form
      this.Stage.push(data.data.start_time)
      this.Stage.push(data.data.end_time)
    },
    //参会专家 获取专家列表
    async getExpertList() {
      const { data: data } = await this.$http.post('expert/all')
      this.expertObject = data.data
    },
    //项目列表参会专家
    async getProjectList() {
      const { data: data } = await this.$http.post('select/expert', { project_id: this.$route.query.project_id })
      this.reference.expert = data.data

    },
    //会议时间
    changessss(e) {
      this.reference.start_time = this.Stage[0]
      this.reference.end_time = this.Stage[1]
    },
    //会议类别 
    async getcate() {
      const { data: data } = await this.$http.post('cate/list', { type: 5 })
      this.categoryList = data.data
    },
    //会议形式 
    async getForm() {
      const { data: data } = await this.$http.post('cate/list', { type: 13 })
      this.meeting_formList = data.data
    },
    //会议模式 
    async getMode() {
      const { data: data } = await this.$http.post('cate/list', { type: 12 })
      this.meeting_ModeList = data.data
    },
    change(e) {
      this.meetingIndex = e
    },
    //图片上传成功
    handleAvatarSuccess(res, file, fileList) {
      if (res.code != 200) {
        this.$refs.imageUrl.clearFiles()
        this.$message.error(res.message)
        return
      }
      this.$Loading.finish()
      this.imageUrl = URL.createObjectURL(file.raw);
      this.reference.logo = res.data.url
    },
    // 滚动条定位到第一个校验失败的div的位置
    locateToErr() {
      setTimeout(() => {
        let errorDiv = document.getElementsByClassName('is-error')
        errorDiv[0].scrollIntoView()
      }, 0)
    },
    // 点击提交表单 
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitApi()
        } else {
          this.locateToErr()
          return false;
        }
      });
    },
    //提交表单api  
    async submitApi() {
      const { data: data } = await this.$http.post('meeting/add', this.reference)
      this.$message({
        message: data.message,
        type: 'success'
      });
      this.$router.back()
    },
    //点击每一页  
    currentchange(e) {
      this.currentPage = e
      this.getExpertList()
    },
    //上一页  
    prevClick(e) {
      this.currentPage = e
      this.getExpertList()
    },
    //下一页 
    nextClick(e) {
      this.currentPage = e
      this.getExpertList()
    },
    //返回
    backProject() {
      this.$router.back()
    },
  }
}
</script>

<style lang='less' scoped>
.contain {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .title_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e8e8e8;
    padding-bottom: 16px;
    margin-bottom: 23px;

    h4 {
      font-size: 28px;
      color: #212529;
    }
  }

  .box-card {
    width: 100%;
    flex: 1;
    // overflow-y: auto;
  }

  /deep/.el-select {
    display: block;
  }

  // 上传图片的样式
  /deep/ .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    width: 66px;
    height: 66px;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 30px;
    height: 30px;
    line-height: 66px;
    text-align: center;
  }

  .avatar {
    width: 66px;
    height: 66px;
    display: block;
  }

  // 上传图片样式结束

  /deep/ .el-card {
    overflow: visible;
  }
}
</style>
